import { Icon } from '@smartgift/frontend-toolkit';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { withTheme } from 'styled-components';

import { MoreInformationModal } from '../MoreInformationModals';

const BrowseCollectionMoreInformationModal = ({ theme, isModalOpen, onRequestClose }) => {
  const { t } = useTranslation();
  return (
    <MoreInformationModal
      isModalOpen={isModalOpen}
      onRequestClose={onRequestClose}
      contentList={[
        {
          title: t('browseCollections'),
          description: t('browseCollectionDesc'),
          icon: (
            <Icon
              name="preview"
              color="var(--color-accent-primary-default)"
              style={{ marginRight: 16, marginTop: 4 }}
            />
          ),
          images: [
            {
              src: theme.images.giftBasketMoreInformation11,
              alt: t('pickYourOwnCollection')
            }
          ]
        }
      ]}
    />
  );
};

export default withTheme(BrowseCollectionMoreInformationModal);
